import React from "react";
import ata from "assets/images/ata.png";
import iso from "assets/images/iso.png";

export default function TranslationServices({backgroundCol}) {
  return (
    <section className={`${backgroundCol ? backgroundCol :"bg-darkBlue"} py-24`}>
      <div className=" px-4 flex items-center justify-center flex-col gap-y-10" >
        <h2 className="text-gray text-3xl md:text-[35px] text-center font-secondary font-semibold leading-10">
          Fully <span className="text-lightBlue">Accredited</span> Translation
          Services
        </h2>

          <div className="grid gap-10 max-w-lg w-full lg:w-5/12 lg:gap-5 lg:grid-cols-2 lg:max-w-[44rem] place-items-center">
            <div>
              <img src={ata} alt="ata_corporate_number" className="w-222"/>
              <p className="text-white font-opensans text-center text-sm mt-5">
                ATA Corporate Member Number 272444
              </p>
            </div>
            <div>
              <img src={iso} alt="iso_certified" />
            </div>
        </div>
      </div>
    </section>
  );
}
